(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_carousel-content"] && !Shopify.designMode) return;
  try {
    /* Forward clicks from meta-image-container to card__link
     since card__link has pointer-events: none for hover fix */
  document.querySelectorAll('.carousel-content .meta-image-container').forEach(container => {
    container.addEventListener('click', () => {
      container.closest('.card')?.querySelector('.card__link')?.click();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
